const DISH_TYPES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default DISH_TYPES_INITIAL_STATE
